module.exports = __webpack_public_path__ + "595a4935f15b74d469b294d8d9a307e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-18.png
// module id = 1564
// module chunks = 0